(() => {
  function updateStoreRating() {
    const reviews = document.getElementById('WiolettaStoreReviews');
    const values = reviews ? [...reviews.querySelectorAll('[data-rating]')].map(el => Number(el.dataset.rating)).filter(n => n > 0 && n <= 5) : [];
    document.querySelectorAll('[data-wioletta-store-rating]').forEach(row => {
      row.hidden = !values.length;
      if (!values.length) return;
      const mean = values.reduce((a,b) => a+b,0) / values.length;
      const score = Math.round(mean*10)/10;
      row.style.setProperty('--wioletta-rating-fill', `${score*20}%`);
      row.querySelector('.wioletta-product-rating__value').textContent = score.toFixed(1).replace('.', ',') + '/5';
      row.querySelector('[data-review-count]').textContent = values.length;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateStoreRating);
  else updateStoreRating();
  document.addEventListener('shopify:section:load', updateStoreRating);
  document.addEventListener('shopify:section:unload', () => setTimeout(updateStoreRating, 0));
})();
